// src/AltArrowCollapse.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AltArrowCollapse_default = createIcon({
  displayName: "ArrowCollapse",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.6315 11.5863L15.4525 15.4072C15.8665 15.8212 16.5385 15.8212 16.9525 15.4072C17.3665 14.9932 17.3665 14.3212 16.9525 13.9072L12.3385 9.29325C11.9475 8.90225 11.3145 8.90225 10.9245 9.29325L6.3105 13.9072C5.8965 14.3212 5.8965 14.9932 6.3105 15.4072C6.7245 15.8212 7.3965 15.8212 7.8105 15.4072L11.6315 11.5863Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  AltArrowCollapse_default
};
